// extracted by mini-css-extract-plugin
export default {"banner_bottom_mobile":"CansContainer_banner_bottom_mobile__jX5hx"};